import React from 'react'
import styled from 'styled-components'

const DaySection = ({ dayTitle, children }) => (
  <div>
    <Title>{dayTitle}</Title>
    {children}
  </div>
)

const Title = styled.div.attrs({ className: 'title is-5' })`
  margin-bottom: 1rem;

  @media screen and (max-width: 1088px) {
    padding: 0 8px;
  }
`

export default DaySection



// WEBPACK FOOTER //
// ./src/components/templates/moment/DaySection.js